<mat-toolbar class="topbar topbar-xl m-auto h-auto p-y-8 po-fixed">
  <div class="container full-width p-xs-0">
    <a href="/">
      <img class="d-block" [src]="tenantService.getDesktopLogo()" />
    </a>
    <span class="flex-1-auto"></span>
    <div class="d-none d-sm-flex">
      <a class="action-btn m-t-4 f-w-600 text-secondary" (click)="signOut()"
        >Sign Out</a
      >
    </div>
  </div>
</mat-toolbar>

<div class="nfc-card-landing">
  <div class="container">
    <div class="header-section text-center">
      <h1 class="f-s-36 f-w-600 m-b-16">Get Your Digital NFC Card</h1>
      <p class="f-s-18 f-w-400 text-secondary m-b-32">
        3 Simple Steps in 5 Minutes
      </p>
    </div>

    <div class="steps-container">
      <div class="step-card">
        <div class="step-number">1</div>
        <div class="step-content">
          <h3 class="f-s-24 f-w-600 m-b-8">Build Your Profile</h3>
          <p class="f-s-16 f-w-400 text-secondary">
            Create your professional profile with your business details and
            contact information.
          </p>
        </div>
      </div>

      <div class="step-card">
        <div class="step-number">2</div>
        <div class="step-content">
          <h3 class="f-s-24 f-w-600 m-b-8">Choose Your Card Design</h3>
          <p class="f-s-16 f-w-400 text-secondary">
            Select from our range of professional card designs that match your
            brand.
          </p>
        </div>
      </div>

      <div class="step-card">
        <div class="step-number">3</div>
        <div class="step-content">
          <h3 class="f-s-24 f-w-600 m-b-8">Print And Pick It</h3>
          <p class="f-s-16 f-w-400 text-secondary">
            Get your digital NFC card ready for use in minutes.
          </p>
        </div>
      </div>
    </div>

    <div class="cta-section text-center">
      <button
        mat-flat-button
        color="primary"
        class="get-started-btn"
        (click)="startApplication()"
      >
        Get Started
      </button>
    </div>
  </div>
</div>
